module.exports = __webpack_public_path__ + "static/img/WRP825_A.79e24f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WRP825_A.jpg
// module id = crZ7
// module chunks = 0